import {
  LogLevels
} from "@backmarket/front-logger";
import { LogLevel, faro } from "@grafana/faro-web-sdk";
import { flattenAttributes } from "./flattenAttributes.js";
const faroLogLevels = {
  [LogLevels.DEBUG]: LogLevel.DEBUG,
  [LogLevels.INFO]: LogLevel.INFO,
  [LogLevels.ERROR]: LogLevel.ERROR
};
export function createFaroTransport({
  level
} = {}) {
  return {
    level,
    name: 2,
    log(transformedLog) {
      if (!("window" in globalThis)) return;
      if (!faro?.api) return;
      const logLevel = LogLevels[transformedLog.SeverityText];
      const context = flattenAttributes(transformedLog.Attributes);
      if (logLevel === LogLevels.ERROR) {
        const error = transformedLog.error ? Object.assign(new Error(transformedLog.error.message), {
          name: transformedLog.error.name,
          stack: transformedLog.error.stack,
          cause: transformedLog.error.cause
        }) : new Error(transformedLog.Body);
        faro.api.pushError(error, { context });
      }
      faro.api.pushLog([transformedLog.Body], {
        level: faroLogLevels[logLevel],
        context
      });
    }
  };
}
